import axios from "axios"
import imageCompression from "browser-image-compression"
import heic2any from "heic2any";

export const fetchCode = () => {
    const authUrl = `https://my.pcloud.com/oauth2/authorize?client_id=yaq4OGzqlX4&response_type=code`

    window.open(authUrl, '_blank', 'noopener,noreferrer')
}

export const fetchToken = async (code: string) => {
    try {
        const res = await axios.get(`/.netlify/functions/fetchToken?code=${code}`);
        return res
    } catch (err) {
        console.error('Error fetching collections:', err)
    }
}

export async function fetchGallery() {
    try {
        const res = await axios.get("/.netlify/functions/fetchGallery")
        return res.data
    } catch (err) {
        console.error(err)
        return []
    }
}

export async function fetchFolderContents(token: string, folderid: string) {
    try {
        const res = await axios.get("https://api.pcloud.com/listfolder", {
            params: {
                folderid: folderid,
                access_token: token  // must be exactly this key
            }
        });

        return res
    } catch (err) {
        console.error(err);
    }
}


export async function createFolder(token: string, folderName: string) {
    try {
        const res = await axios.post(`/.netlify/functions/createFolder?access_token=${token}&folderName=${folderName}`);
        return res.data.metadata
    } catch (err) {
        console.error(err)
    }
}

export async function deleteFolder(token: string, folderid: string) {
    try {
        const res = await axios.delete(`/.netlify/functions/deleteFolder?access_token=${token}&folderid=${folderid}`);
        return res.data.metadata
    } catch (err) {
        console.error(err)
    }
}

async function convertAndCompress(file: File) {
    let workingFile = file;

    if (
        file.type === "image/heic" ||
        file.type === "image/heif" ||
        file.name.includes('.heic') ||
        file.name.includes('.heif')
    ) {
        const blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9,
        });

        workingFile = new File([blob as Blob], file.name.replace(/\.heic/i, ".jpg"), {
            type: "image/jpeg",
        });
    }

    // THEN compress normally
    const compressed = await imageCompression(workingFile, {
        maxSizeMB: 1,
        maxWidthOrHeight: 850,
        useWebWorker: true,
    });

    return compressed;
}


export async function uploadFile(token: string, file: File, folderid: string) {
    try {
        const compressedFile = await convertAndCompress(file);

        // console log for debugging
        // console.log("Before:", file);
        // console.log("After:", compressedFile);

        const form = new FormData();
        const maxNameLength = 30

        let fileName: string;
        if (compressedFile.name.length <= maxNameLength) {
            fileName = compressedFile.name
        } else {
            const dotIndex = compressedFile.name.lastIndexOf(".");
            const ext = dotIndex !== -1 ? compressedFile.name.slice(dotIndex) : "";
            const base = compressedFile.name.slice(0, maxNameLength - ext.length - 3);
            fileName = base + ext;
        }

        form.append("file", compressedFile, fileName);
        form.append("filename", fileName);
        form.append("folderid", folderid);
        form.append("access_token", token);

        const res = await axios.post(
            "/.netlify/functions/uploadFile",
            form,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return res.data.metadata
    } catch (err) {
        console.error(err)
    }
}

export async function deleteFile(token: string, fileid: string) {

    try {
        const res = await axios.delete(`/.netlify/functions/deleteFile?access_token=${token}&fileid=${fileid}`);
        return res
    } catch (err) {
        console.error(err)
    }


}
